import React from 'react';
import Scrollbars from 'react-custom-scrollbars';

import OrderRealizationsItem from '../order-realizations-item/order-realizations-item';
import { OrderRealizationsItemProps } from '../types';

import './order-realizations-list.scss';

interface OrderRealizationsListProps {
  data: OrderRealizationsItemProps[];
}

const OrderRealizationsList: React.FC<OrderRealizationsListProps> = ({
  data,
}) => (
  <Scrollbars autoHide>
    <ul className="realization__list">
      {data.map((item, index) => (
        <li className="realization__item" key={`realization__item-${index}`}>
          <OrderRealizationsItem
            title={item.title}
            count={item.count}
            sum={item.sum}
          />
        </li>
      ))}
    </ul>
  </Scrollbars>
);

export default OrderRealizationsList;
